<template>
    <div></div>
</template>
<script>
export default {
    mounted(){
        // 外部广告 
        window.location.href='http://wechatpay.yutai365.com/wechatlink/param/dXNlcmlkPTgxNzE2NC9wcm9kdWN0Q29kZT1GWExIQVdZL2Zyb21QdWJsaWM9WQ%3D%3D'
    }
}
</script>